import { defineStore } from 'pinia'

import { createInternalOrdersState } from './state'
import { createInternalOrdersActions } from './actions'

export const useInternalOrdersStore = defineStore('internalOrders', () => {
    const state = createInternalOrdersState()
    const actions = createInternalOrdersActions(state)

    return {
        ...state,
        ...actions
    }
})
